module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-screen@2x-a4f90f3c4553ce9dbb79210ec407d7e3.png";